import { Stack } from '@mui/material';
import dayjs from 'dayjs';

import { DATE_TIME_CALC_FORMAT } from '@/constants/date.constants';
import useStyles from '@/pages/Administration/AdministrationGeneral/AdministrationGeneral.styles';

const FullTicketTemplate = () => {
  const { classes } = useStyles();

  return (
    <Stack className={classes.newTicketTemplate}>
      <div className={classes.newTicketTemplateItem}>
        <b>Title:</b> Example Ticket
      </div>
      <div className={classes.newTicketTemplateItem}>
        <b>Timestamp:</b> {dayjs().format(DATE_TIME_CALC_FORMAT)} UTC
      </div>
      <div className={classes.newTicketTemplateItem}>
        <b>Priority:</b> P3
      </div>
      <div className={classes.newTicketTemplateItem}>
        <b>Category:</b> Malware
      </div>
      <div className={classes.newTicketTemplateItem}>
        <b>Summary:</b> More information that is being provided regarding the
        specified ticket. This section may contain more specific details about
        the issue.
      </div>
      <div className={classes.newTicketTemplateItem}>
        <b>Recommendations:</b> This section provides action items that will
        help address the issue.
      </div>
      <div className={classes.newTicketTemplateItem}>
        <b>Comments:</b> This section contains recent comments left on the
        ticket.
      </div>
      <div className={classes.newTicketTemplateItem}>
        <b>Affected Hosts:</b>
        <ul>
          <li>
            <b>IP:</b> 1.1.1.1
          </li>
          <li>
            <b>Domain:</b> www.pondurance.com
          </li>
          <li>
            <b>Email:</b> soc@pondurance.com
          </li>
          <li>
            <b>Detection Method:</b> Network
          </li>
        </ul>
      </div>
      <div className={classes.newTicketTemplateItem}>
        <b>External Threats:</b>
        <ul>
          <li>
            <b>IP:</b>1.1.1.1
          </li>
        </ul>
      </div>
      <div className={classes.newTicketTemplateItem}>
        <b>Link:</b>{' '}
        <a
          className={classes.linkText}
          target="_blank"
          rel="noreferrer"
          href="https://scope.pondurance.com/"
        >
          A link to the ticket
        </a>
      </div>
      <div className={classes.newTicketTemplateItem}>
        <b>Investigate:</b>{' '}
        <a
          className={classes.linkText}
          target="_blank"
          rel="noreferrer"
          href="https://scope.pondurance.com/"
        >
          Informational Link
        </a>
      </div>
    </Stack>
  );
};

export default FullTicketTemplate;
